import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import LoginPageSlidesSmall from "../auth/LoginPageSlidesSmall";
import LoginPageLatestNewsSmall from "../auth/LoginPageLatestNewsSmall";
import LoginPageLinksSmall from "../auth/LoginPageLinksSmall";
import ContactUsSmall from "./ContactUsSmall";
import ContactTenantsSmall from "./ContactTenantsSmall";
import DisclaimerSmall from "./DisclaimerSmall";
import AlertListSmall from "./AlertListSmall";
import AlertHistorySmall from "./AlertHistorySmall";
import { userProfileIconBlue } from '../../img/font_awesome/font_awesome';
import Logout from "../top/Logout";
import packageJson from '../../../package.json';

export default function HomeSmall() {
	const history = useHistory();
	const serverProductVersions = useSelector((state) => state.serverProductVersionsReducer.combinedVersion);
	const currentUserName = useSelector((state) => state.currentUserReducer.username);
	const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
	const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);
	const multiTenantSettings = useSelector((state) => state.countyConfigMultiTenantSettingsReducer);

	let copyrightYear = new Date().getFullYear();
	if (copyrightYear > 2022) {
		copyrightYear = '2022-' + copyrightYear;
	}

	const [openLatestNews, setOpenLatestNews] = React.useState(false);
	const [openSlides, setOpenSlides] = React.useState(false);
	const [openLinks, setOpenLinks] = React.useState(false);
	const [openContactUs, setOpenContactUs] = React.useState(false);
	const [openContactTenants, setOpenContactTenants] = React.useState(false);
	const [openDisclaimer, setOpenDisclaimer] = React.useState(false);
	const [showLogout, setShowLogout] = React.useState(false);
	const [loginSlidesCard, setLoginSlidesCard] = React.useState(false);
	const [latestNewsCard, setLatestNewsCard] = React.useState(false);
	const [linksCard, setLinksCard] = React.useState(false);
	const [contactUsCard, setContactUsCard] = React.useState(false);
	const [disclaimerCard, setDisclaimerCard] = React.useState(false);
	const isNarrowScreen = window.innerWidth <= 360;

	const bannerRef = React.useRef(null);
	const [bannerHeight, setBannerHeight] = React.useState(80);

	React.useEffect(() => {
		if (!bannerRef.current) return;
		setBannerHeight(bannerRef.current.offsetHeight);
	}, [isNarrowScreen]);

	React.useEffect(() => {
		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/all", { withCredentials: true })
			.then((response) => {
				const selections = response.data.content.selections;
				setLoginSlidesCard(selections.loginSlides);
				setLatestNewsCard(selections.latestNews);
				setLinksCard(selections.links);
				setContactUsCard(selections.contactUs);
				setDisclaimerCard(selections.disclaimer);
			})
			.catch((error) => {
				handleError(error, history);
			});
	}, [history]);

	const handleUserProfileClick = () => {
		history.push("/currentUserMobile");
	};

	const handleLogoutClick = () => {
		setShowLogout(true);
	};

	return (
		<div>
			<div style={styles.banner} ref={bannerRef}>

				{/* Center: Title */}
				<div style={styles.titleContainer}>
					<div
						style={{
							...styles.title,
							fontSize: isNarrowScreen ? "16px" : "20px",
						}}
					>
						{countyName}</div>
					<div
						style={{
							...styles.subtitle,
							fontSize: isNarrowScreen ? "13px" : "16px",
						}}
					>
						{appTitle}</div>
				</div>

				{/* Right: Log In */}
				<div style={styles.right}>
					<button style={styles.userProfileButton} onClick={handleUserProfileClick}>
						{userProfileIconBlue}
					</button>
					<button style={styles.logoutButton} onClick={handleLogoutClick}>
						Logout
					</button>
				</div>
			</div>

			<div style={{ ...styles.content, marginTop: `${bannerHeight}px` }}>

				<div style={styles.greeting}>Hello, {currentUserName}</div>

				<AlertListSmall />

				<AlertHistorySmall />

				{
					latestNewsCard &&
					<LoginPageLatestNewsSmall
						isOpen={openLatestNews === true}
						onToggle={() =>
							setOpenLatestNews(
								!openLatestNews
							)
						}
					/>
				}

				<div style={{ height: "2px" }} />

				{
					loginSlidesCard &&
					<div
						style={{
							...styles.accordionContainer,
							boxShadow: openSlides
								? "0 4px 10px rgba(0,0,0,0.08)"
								: "0 1px 3px rgba(0,0,0,0.05)",
						}}
					>
						<div
							style={{
								...styles.accordionHeader,
								backgroundColor: openSlides ? "#5A6268" : "#6C757D",
							}}
							onClick={() => setOpenSlides(!openSlides)}
						>
							<span>Land Notification</span>

							<span
								style={{
									...styles.accordionIcon,
									transform: openSlides ? "rotate(180deg)" : "rotate(0deg)",
									transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
									display: "inline-block",
								}}
							>
								▼
							</span>
						</div>

						<div
							style={{
								...styles.accordionWrapper,
								maxHeight: openSlides ? "2000px" : "0px",
							}}
						>
							<div
								style={{
									...styles.accordionContent,
									opacity: openSlides ? 1 : 0,
									transition: "opacity 0.2s ease 0.08s",
								}}
							>
								<LoginPageSlidesSmall bare />
							</div>
						</div>
					</div>
				}

				{
					linksCard &&
					<div
						style={{
							...styles.accordionContainer,
							boxShadow: openLinks
								? "0 4px 10px rgba(0,0,0,0.08)"
								: "0 1px 3px rgba(0,0,0,0.05)",
						}}
					>
						<div
							style={{
								...styles.accordionHeader,
								backgroundColor: openLinks ? "#5A6268" : "#6C757D",
							}}
							onClick={() => setOpenLinks(!openLinks)}
						>
							<span>Useful Links</span>

							<span
								style={{
									...styles.accordionIcon,
									transform: openLinks ? "rotate(180deg)" : "rotate(0deg)",
									transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
									display: "inline-block",
								}}
							>
								▼
							</span>
						</div>

						<div
							style={{
								...styles.accordionWrapper,
								maxHeight: openLinks ? "2000px" : "0px",
							}}
						>
							<div
								style={{
									...styles.accordionContent,
									opacity: openLinks ? 1 : 0,
									transition: "opacity 0.2s ease 0.08s",
								}}
							>
								<LoginPageLinksSmall bare />
							</div>
						</div>
					</div>
				}

				{
					contactUsCard && multiTenantSettings.multiTenant !== true &&
					<ContactUsSmall
						isOpen={openContactUs === true}
						onToggle={() =>
							setOpenContactUs(
								!openContactUs
							)
						}
					/>
				}

				{
					contactUsCard && multiTenantSettings.multiTenant === true &&
					<ContactTenantsSmall
						isOpen={openContactTenants === true}
						onToggle={() =>
							setOpenContactTenants(
								!openContactTenants
							)
						}
					/>
				}

				{
					disclaimerCard &&
					<DisclaimerSmall
						isOpen={openDisclaimer === true}
						onToggle={() =>
							setOpenDisclaimer(
								!openDisclaimer
							)
						}
					/>
				}
			</div>

			<div style={styles.footer}>
				<div>
					Powered by <strong>TriMin Systems Land Notification v{packageJson.version}u{serverProductVersions}</strong>
				</div>

				<div style={styles.footerDescription}>
					Land Notification is designed, engineered, and supported in
					St. Paul, MN, and is part of our land records management
					software suite.
				</div>

				<div style={styles.copyright}>
					© {copyrightYear} TriMin Systems
				</div>
			</div>

			<Logout show={showLogout} closeLogout={() => setShowLogout(false)} history={history} />
		</div>
	);
}

// Styles
const styles = {

	banner: {
		display: "grid",
		gridTemplateColumns: "auto 1fr auto",
		alignItems: "center",
		backgroundColor: "#114E6B",
		color: "white",
		padding: "14px 16px",
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		boxSizing: "border-box",
		overflowX: "hidden",
		zIndex: 1000,
	},

	left: {
		justifySelf: "start",
	},
	right: {
		justifySelf: "end",
		display: "flex",
		gap: "14px",
	},

	greeting: {
		color: "#114E6B",
		fontWeight: "bold",
		fontSize: "14px",
		textAlign: "right",
		marginBottom: "12px",
	},

	titleContainer: {
		marginLeft: "8px",
		textAlign: "left",
	},

	title: {
		fontWeight: "700",
		fontSize: "20px",
		lineHeight: "1.2",
		color: "white",
	},

	subtitle: {
		fontSize: "16px",
		letterSpacing: "0.5px",
		opacity: 0.9,
		color: "white",
	},

	userProfileButton: {
		backgroundColor: "white",
		color: "#114E6B",
		border: "none",
		padding: "10px 16px",
		borderRadius: "6px",
		cursor: "pointer",
		fontWeight: "700",
		fontSize: "14px",
	},

	logoutButton: {
		backgroundColor: "#DC3545",
		color: "white",
		border: "2px solid white",
		padding: "8px 14px",
		borderRadius: "6px",
		cursor: "pointer",
		fontWeight: "700",
		fontSize: "14px",
	},

	content: {
		padding: "16px",
	},

	accordionContainer: {
		marginTop: "16px",
		border: "2px solid #6C757D",
		borderRadius: "6px",
		overflow: "hidden",
		transition: "box-shadow 0.3s ease",
		boxShadow: "0 4px 12px rgba(108, 117, 125, 0.12)",
	},

	accordionHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "10px 12px",
		cursor: "pointer",
		backgroundColor: "#6C757D",
		fontWeight: "bold",
		color: "white",
		transition: "background-color 0.2s ease",
	},

	accordionIcon: {
		fontSize: "12px",
	},

	accordionWrapper: {
		overflow: "hidden",
		transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
	},

	accordionContent: {
		backgroundColor: "white",
	},

	footer: {
		marginTop: "24px",
		padding: "16px",
		borderTop: "1px solid #D8E4EA",
		backgroundColor: "#FAFCFD",
		textAlign: "left",
		fontSize: "12px",
		color: "#114E6B",
		lineHeight: "1.5",
	},

	copyright: {
		opacity: 0.8,
	},

	logoContainer: {
		width: "40px",
		height: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "20px",
		fontWeight: "bold",
		color: "white",
	},
};
